import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";

/**
 * Client-safe. The better-auth React client backing sign-up/sign-in/sign-out
 * calls from Client Components. Talks to app/api/auth/[...all]/route.ts.
 */
export const authClient = createAuthClient({
  plugins: [organizationClient()],
});
